export type StackFilter = 'all' | 'my-table' | 'eliminated'

/**
 * Filter chips for the Stack page. Three lenses on the same dataset:
 *  - all: everyone (active above + eliminated below)
 *  - my-table: just the players at the auth player's table
 *  - eliminated: just the bust list
 *
 * "my-table" is hidden when the player has no table assignment (pre-draw
 * deep link). "eliminated" is hidden when zero players are out.
 */
const StandingsFilter = ({
  value,
  onChange,
  hasTable,
  hasEliminated,
}: {
  value: StackFilter
  onChange: (next: StackFilter) => void
  hasTable: boolean
  hasEliminated: boolean
}) => {
  const items: { key: StackFilter; label: string; show: boolean }[] = [
    { key: 'all', label: 'Alle', show: true },
    { key: 'my-table', label: 'Mitt bord', show: hasTable },
    { key: 'eliminated', label: 'Slått ut', show: hasEliminated },
  ]
  return (
    <div
      className="flex gap-2 px-2 py-2 overflow-x-auto"
      role="tablist"
      aria-label="Filter"
    >
      {items
        .filter((i) => i.show)
        .map((i) => {
          const active = i.key === value
          return (
            <button
              key={i.key}
              type="button"
              role="tab"
              aria-selected={active}
              onClick={() => onChange(i.key)}
              className={`px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider active:opacity-70 ${
                active
                  ? 'bg-green-700 text-paper'
                  : 'bg-paper text-ink-700 border border-ink-200'
              }`}
            >
              {i.label}
            </button>
          )
        })}
    </div>
  )
}

export default StandingsFilter
